module.exports = __webpack_public_path__ + "img/NorCod med i TERRAVERA Business Program.27edda7f.png";